import { Row } from "antd";
import chat from "../../../../../images/chat.svg";

type EmptyListProps = {
  data: {
    title: string;
    subTitle: string;
  };
};

export const EmptyList = ({ data }: EmptyListProps) => {
  return (
    <Row className="d-block no-messages w-100">
      <Row className="w-100 justify-center image">
        <img src={chat} alt="chat" className="logo-cursor" />
      </Row>
      <Row className="w-100 justify-center mb-1">
        <p className="my-0 text">{data.title}</p>
      </Row>
      <Row className="w-100 justify-center">
        <p className="my-0 text-md title text-center">{data.subTitle}</p>
      </Row>
    </Row>
  );
};
